<h1 mat-dialog-title>Votre contrat est prêt.</h1>
<div mat-dialog-content style="max-height: none">
  @if (safeUrl) {
    <iframe [src]="safeUrl" width="100%" height="700" frameborder="0"></iframe>
  }
</div>

<div mat-dialog-actions>
  <pr-button
    size="lg"
    type="button"
    display="danger"
    label="Fermer"
    (click)="onNoClick()"
  ></pr-button>
</div>
